<template>
<div>
    <div class="modal fade" id="add_cities" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document" style="overflow-y: initial !important">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="add_table_label">Add/Update Cities</h4>
                </div>

                <div class="modal-body" style="max-height: 60vh;overflow-y: auto;">
                    <form method="post" @submit.prevent="addCity()">
                        <div class="form-group">
                            <label for="name">City Name</label>
                            <input type="text" v-model="city.city" required class="form-control" placeholder="Name">
                        </div>
                    <button type="submit" class="btn btn-primary pull-right" style="margin:10px;">Add City</button>
                    </form>
                    <br>
                    <table class="table table-bordered table-hover table-stripped"> 
                        <thead>
                            <tr>
                                <th class="text-center">ID</th>
                                <th class="text-center">City Name</th>
                                <th class="text-center"><i class="fa fa-bolt"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(city, cityIndex) in cities">
                                <tr :key="cityIndex + '_' + city.id">
                                    <td class="text-center">{{city.id}}</td>
                                    <td class="text-center">{{city.city}}</td>
                                    <th class="text-center"><button @click="editCity(city.id, city.city)" class="btn btn-success"><i class="fa fa-pencil"></i></button></th>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
    export default {
        name: "addCities",
        data() {
          return {
              cities:[],
              city:{
                  id:0,
                  city:''
              }
          }
        },
        updated: function(){
            $('#add_cities').on('hidden.bs.modal', ()=>{
                this.resetCityObj();
            });
        },
        methods: {
             load() {
                this.$http.post(this.$store.state.mainAppURL + "areas/get_all_cities").then(resp=>{
                    this.cities= resp.data;
                })
                $('#add_cities').modal("show")
            },
            addCity: function(){
                    Swal.fire({
                        title: 'Please Wait! We are processing the data.',
                        type: 'info',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        onBeforeOpen: () => {
                            Swal.showLoading();
                        },
                    });
                this.$http.post(this.$store.state.mainAppURL + "areas/save_new_city", this.city).then(async resp=>{
                    this.cities= resp.data;
                    this.resetCityObj();
                    Swal("Added","New City Has Been Added", "success");
                }).catch(ex => {
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
            },
            editCity: async function(cityId, cityName){

                $('#add_cities').modal("hide")
                this.inputValue= cityName;
                const { value: editedCityName} = await Swal.fire({
                    title: "Edit City Name",
                    text: cityName,
                    input: 'text',
                    inputLabel: 'City Name',
                    inputValue: cityName,
                    showCancelButton: true,
                    confirmButtonText: 'Punch',
                    showLoaderOnConfirm: true,
                preConfirm: (editedCityName) => {
                    this.city.city= editedCityName;
                    this.city.id= cityId;
                    this.$http.post(this.$store.state.mainAppURL + "areas/save_new_city", this.city).then(resp=>{
                    this.cities= resp.data;
                    this.resetCityObj();
                    Swal("Updated","City Has Been Updated", "success");
                    $('#add_cities').modal("show");
                }).catch(ex => {
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
                }, 
                allowOutsideClick: () => !Swal.isLoading(),
                inputValidator: (value) => {
                    if (!value) {
                    return 'Enter City Name'
                    }
                }
                });
                $('#add_cities').modal("show");
            },
            resetCityObj:function(){
                this.city={
                    id:0,
                    city:""
                }
            },
        },
    }
</script>

<style scoped>

</style>
